import BorderBox from './borderBox';
import BorderRadius from './borderRadius';
import BoxShadow from './boxShadow';
import { borderFieldsArr, borderRadiusFieldsArr } from './borderUtils';
import { COLOR_PICKER_INIT_VALUE } from '../../utils/constant';
import { pick, get } from "lodash-es";
import StylePanelMixin from "../../utils/StylePanelMixin";
const __script_base__ = {
  name: 'SPBorder',
  components: {
    BorderBox,
    BorderRadius,
    BoxShadow
  },
  extends: StylePanelMixin,
  data() {
    return {
      selectedBorder: 'none',
      borderWidth: 0,
      defaultColor: COLOR_PICKER_INIT_VALUE,
      currentBorderField: 'border',
      borderStyleOption: [{
        value: 'solid',
        label: '实线'
      }, {
        value: 'dotted',
        label: '点线'
      }, {
        value: 'dashed',
        label: '虚线'
      }]
    };
  },
  computed: {
    borderField() {
      const res = {
        width: [],
        style: [],
        color: [],
        radius: []
      };
      borderFieldsArr.forEach(field => {
        res.width = [...res.width, `${field}Width`];
        res.style = [...res.style, `${field}Style`];
        res.color = [...res.color, `${field}Color`];
      });
      borderRadiusFieldsArr.forEach(borderField => {
        res.radius = [...res.radius, `${borderField}Radius`];
      });
      return res;
    },
    borderFieldSetColors() {
      return pick(this.style, this.borderField.color);
    },
    borderFieldSetStyles() {
      return pick(this.style, this.borderField.style);
    },
    borderFieldSetWidths() {
      return pick(this.style, this.borderField.width);
    },
    borderFieldSetRadiuses() {
      return pick(this.style, this.borderField.radius);
    },
    borderFieldSetShadows() {
      let expr = get(this.style, 'boxShadow');
      if (!expr) return [];
      let cur;
      const ans = [];
      while (expr) {
        const m = expr.match(/^,|^([^\s,(]+|\([^)]*\)?)+/);
        if (!m) {
          const spaces = expr.match(/^\s+/);
          if (!spaces) break; // corrupted

          expr = expr.slice(spaces[0].length);
          continue;
        }
        const p = m[0];
        expr = expr.slice(p.length);
        if (!cur) {
          cur = {
            inset: false,
            color: '',
            coords: []
          };
          ans.push(cur);
        }
        if (p === ',') {
          cur = null;
        } else if (p === 'inset') {
          cur.inset = true;
        } else if (/^-?[\d.]+(\w+|%)?$/.test(p)) {
          cur.coords.push(p);
        } else {
          cur.color = p;
        }
      }
      return ans.filter(x => x.coords.length >= 2);
    }
  },
  methods: {
    changeBorderInfo([path, value, selectedBorder]) {
      if (selectedBorder === 'border') {
        const attr = path.replace(selectedBorder, '');
        if (attr === 'Radius') {
          borderRadiusFieldsArr.forEach(field => {
            this.deleteStyle(`${field}${attr}`);
          });
        } else {
          borderFieldsArr.forEach(field => {
            this.deleteStyle(`${field}${attr}`);
          });
        }
      }
      if (value === null) {
        this.$delete(this.style, path);
      } else {
        this.style = {
          ...this.style,
          [path]: value
        };
      }
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "uc-common-input-rapper"
  }, [_c("BorderBox", {
    attrs: {
      "border-field-set-colors": this.borderFieldSetColors,
      "border-field-set-styles": this.borderFieldSetStyles,
      "border-field-set-widths": this.borderFieldSetWidths
    },
    on: {
      change: _vm.changeBorderInfo
    }
  }), _vm._v(" "), _c("BorderRadius", {
    attrs: {
      "border-field-set-radiuses": this.borderFieldSetRadiuses
    },
    on: {
      change: _vm.changeBorderInfo
    }
  }), _vm._v(" "), _c("BoxShadow", {
    attrs: {
      "border-field-set-shadows": this.borderFieldSetShadows
    },
    on: {
      change: _vm.changeBorderInfo
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/PropPanel/StylePanel/comps/Border/border.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);